const getSearchResultsStatusSelector = state => state.results.getResultsStatus;
const getSearchResultsSelector = state => state.results.pool;
const getSearchResultsTotalCountSelector = state => state.results.totalCount;

export {
    getSearchResultsStatusSelector,
    getSearchResultsSelector,
    getSearchResultsTotalCountSelector,
};